import {Device} from "@/models/devices.interface";
import {Message} from "@/models/message.interface";
import {SMSMessage} from "@/models/message.interface";
import {Usuario} from "@/models/user.interface";
import axios from "axios";
import {URL_API} from "@/config/utils";

export class DeviceService{
  BASE_URL:string; 
  constructor(){
    this.BASE_URL=`${URL_API}`
  }

  async getAll(token:string):Promise<Device[]>{
    let list_devices: Array<Device> = [];   

	 const config = {headers:{"Authorization": `Bearer ${token}`}}
	  const resp=await axios.get(`${this.BASE_URL}only_devices`,config);
	  return await resp.data;
  }
  async getAllByMessages(token:Usuario):Promise<Device[]>{
    let list_devices: Array<Device> = [];
    const config = {headers:{"Authorization": `Bearer ${token.token}`}}
    const resp=await axios.get(`${this.BASE_URL}messages`,config);
    const res = await resp.data;

    res.forEach(device=>{
        const messages_d = device.messages;
	let messages : Array<Message>=[];
	messages_d.forEach(message=>{
	      let user_lead = message.attended_by;
	      const new_message:Message={"text":message.text,"date": new Date(message.date_received),"status":message.status,"id":message._id,
	       attended_by:user_lead
	      };
	      messages.push(new_message);
	});
	messages.sort((a:Message,b:Message)=>{return(b.date.getTime()-a.date.getTime()) ;});
	const phone:Device={"_id":device._id,"phone_number":device.phone_number,"phone_alias":device.phone_alias,"location_name":device.location_name,"ip":device.ip,"status":device.status,"messages":messages};
	list_devices.push(phone);
    });

    return list_devices;
  }

  getByDeviceNumber(device_number:string){
    const list_messages_promise =async()=> { const  resp=await axios.get(`${this.BASE_URL}/messages-from-device/${device_number}`);return await resp.data};
    return list_messages_promise();
    
  }

  async getDevicesByNumberAndStatus(token:string,phone_number:string="all",status:string="unattended",ffinicio?:string,ffinal?:string,pagina:number=1):Promise<SMSMessage[]>{
      let list_devices: Array<SMSMessage> = [];
      const config = {headers:{"Authorization": `Bearer ${token}`}}
	let query_params=(phone_number.trim()==""?"&phone_number=all":`&phone_number=${phone_number}`);
	query_params+=(status.trim()==""?"":`&status_message=${status}`)
	query_params+=( ffinicio!="" && ffinicio!=null  && ffinal!="")?(`&finicio=${ffinicio}&ffinal=${ffinal}`):"";
	const resp=await axios.get(`${this.BASE_URL}messages-phone-status-dto?pagina=${pagina}${query_params}`,config);
	const res = await resp.data;
	list_devices = res;


      return list_devices;
  }
  async change_estatus_message(token:string,phone_number:string,message_id:string,status_message:string){

      const config = {headers:{"Authorization": `Bearer ${token}`}};
      const req = await axios.put(`${this.BASE_URL}update_message/${phone_number}/${message_id}`,{status:status_message},config);
      if (req.status==205) return true;
      return false;

  }
}//fin de clase

